<template lang="pug">
v-card
    v-card-title Listing Settings
    v-card-text
        v-container.holder
            v-card(:loading="loading")
                v-card-text
                    v-text-field(label="Community" v-model="form.community" :disabled="loading")
                    v-text-field(label="Profile" v-model="form.profile" :disabled="loading")
                    v-text-field(label="Spotlight" v-model="form.spotlight" :disabled="loading")
                    v-text-field(label="Follow" v-model="form.follow" :disabled="loading")
                    v-text-field(label="Fans" v-model="form.fans" :disabled="loading")
                v-card-actions
                    v-spacer
                    v-btn(color="primary" @click="onSubmit" :disabled="loading") Update

    v-snackbar(v-model="success" top color="green")
        v-icon(left) mdi-alert-circle-outline
        | Successfully Saved!
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="success = false"
            ) Close

    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close
        
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            success: false,
            loading: true,
            error: {
                show: false,
                message: ''
            },
            form: {
                community: null,
                profile: null,
                spotlight: null,
                follow: null,
                fans: null,
            }
        };
    },
    computed: {
        ...mapGetters('bh-settings', { settings: 'find' })
    },
    async created() {
        await this.getSettings({
            query: {
                option_name: { $in: ['community_listing', 'profile_listing', 'spotlight_listing', 'follow_listing', 'fans_listing'] }
            }
        });
        this.form.community = this.getOptions('community_listing').option_value;
        this.form.profile = this.getOptions('profile_listing').option_value;
        this.form.spotlight = this.getOptions('spotlight_listing').option_value;
        this.form.follow = this.getOptions('follow_listing').option_value;
        this.form.fans = this.getOptions('fans_listing').option_value;
        this.loading = false;
    },
    methods: {
        getOptions(option_name) {
            const settings = this.settings({
                query: { option_name }
            });
            return settings.data[0];
        },
        async updateSettings(option_name, option_value) {
            const settings = this.getOptions(option_name);
            settings.option_value = option_value;
            await settings.patch();
        },
        async onSubmit() {
            try {
                this.loading = true;
                
                await this.updateSettings('community_listing', this.form.community);
                await this.updateSettings('profile_listing', this.form.profile);
                await this.updateSettings('spotlight_listing', this.form.spotlight);
                await this.updateSettings('follow_listing', this.form.follow);
                await this.updateSettings('fans_listing', this.form.fans);

                this.success = true;
            } catch(err) {
                this.error.message = err.message;
                this.error.show = true;
            } finally {
                this.loading = false;
            }
        },
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        ...mapActions('bh-settings', { getSettings: 'find' })
    }
}
</script>

<style lang="scss" scoped>
.holder {
    max-width: 710px;
}
</style>